/** @type {(selector: string) => HTMLElement} */
const $ = (selector) => document.querySelector(selector);

export default $;